/** Länderliste für Nationalität (deutsche Bezeichnungen, häufige zuerst). */
export const COUNTRY_OPTIONS = [
  'Deutschland',
  'Österreich',
  'Schweiz',
  'Türkei',
  'Polen',
  'Rumänien',
  'Italien',
  'Spanien',
  'Frankreich',
  'Niederlande',
  'Belgien',
  'Griechenland',
  'Bulgarien',
  'Kroatien',
  'Ungarn',
  'Tschechien',
  'Slowakei',
  'Slowenien',
  'Serbien',
  'Bosnien und Herzegowina',
  'Kosovo',
  'Nordmazedonien',
  'Albanien',
  'Russland',
  'Ukraine',
  'Afghanistan',
  'Ägypten',
  'Algerien',
  'Argentinien',
  'Armenien',
  'Aserbaidschan',
  'Australien',
  'Bangladesch',
  'Belarus',
  'Bolivien',
  'Brasilien',
  'China',
  'Dänemark',
  'Ecuador',
  'Estland',
  'Finnland',
  'Georgien',
  'Ghana',
  'Großbritannien',
  'Indien',
  'Indonesien',
  'Irak',
  'Iran',
  'Irland',
  'Island',
  'Japan',
  'Jordanien',
  'Kanada',
  'Kasachstan',
  'Kenia',
  'Kolumbien',
  'Kuba',
  'Lettland',
  'Libanon',
  'Litauen',
  'Luxemburg',
  'Malaysia',
  'Marokko',
  'Mexiko',
  'Moldau',
  'Mongolei',
  'Nepal',
  'Nigeria',
  'Norwegen',
  'Pakistan',
  'Palästina',
  'Peru',
  'Philippinen',
  'Portugal',
  'Schweden',
  'Senegal',
  'Singapur',
  'Südafrika',
  'Südkorea',
  'Syrien',
  'Thailand',
  'Tunesien',
  'USA',
  'Usbekistan',
  'Venezuela',
  'Vietnam',
  'Zypern'
];
